import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DurationPipe } from '@web/app/pipes/duration/duration.pipe';


@NgModule({
  declarations: [DurationPipe],
  exports: [DurationPipe],
  imports: [
    CommonModule
  ]
})
export class DurationModule { }
